





































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';

const { AgGridVue } = require('ag-grid-vue');

import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { fetchBajasComerciales } from './fetchBajasComerciales';

import TabGeneral from './tabs/TabGeneral.vue';
import TabDetalle from './tabs/TabDetalle.vue';

import { DataApi, DataTabsApi } from './models/BajasComerciales.model';
import Confirmation from '@/components/Confirmation.vue'; //

@Component({
  components: {
    TabGeneral,
    TabDetalle,
    GridComponent: AgGridVue,
    'app-confirmacion': Confirmation,
  },
})
export default class BajasComercialesModalVerDetalle extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ required: true, default: {} }) data!: DataApi;
  @Prop({}) esEdicion: boolean;
  @Prop({ default: false, required: false }) bajaFinalizada: boolean;
  @Prop({}) tramos: any;

  gridOptions: GridOptions = null;
  gridApi: GridApi = null;
  gridEvent: any = null;
  columnApi: any = null;
  editado: boolean = false;

  step: string = 'general';
  dialog: boolean = true;
  loading = false;
  currentId: Record<string, string> = {
    detalles: null,
  };

  dataApi: DataTabsApi = {
    detalles: [],
  };

  readonly loadingService = new LoadingService();
  readonly $snotify: Snotify = null;
  dialogConfirmacionClose: boolean = false;

  constructor() {
    super();
    this.gridOptions = {
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData([{}]);
  }

  handleClosed(): void {
    this.data = {};
    Object.keys(this.currentId).forEach(key => (this.currentId[key] = null));
    this.$emit('cerrar');
  }

  @Watch('step')
  async validateValue() {
    if (this.step === 'detalle' && this.currentId.detalles !== this.data.id) {
      this.dataApi.detalles = await this.getTab({});
      this.currentId.detalles = this.data.id;
    }
  }

  async getTab({ tag = 'detalle' }): Promise<any> {
    this.loading = true;
    this.loadingService.showLoading();
    const self = this;

    return await fetchBajasComerciales({
      endpoint: 'get_tabs',
      body: {
        tag,
        id: this.data.id,
      },
    })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1 || MENSAJE_RESPUESTA) {
          throw new Error(MENSAJE_RESPUESTA);
        }
        return LISTA;
      })
      .catch((err: Error) => {
        if (err instanceof Error && err.message) {
          self.$snotify.error(err.message, { timeout: 3500 });
        } else {
          self.$snotify.error(
            'Ha ocurrido un error inesperado, por favor intente más tarde',
            { timeout: 3500 }
          );
        }
      })
      .finally(() => {
        self.loading = false;
        self.loadingService.hideLoading();
      });
  }

  confirmSave() {
    this.$nextTick(() => {
      (this.$refs.guardar as TabGeneral).guardar(true);
    });
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
  }
  closeModal(val: boolean) {
    this.$validator.reset();
    document.getElementById('cardDivTV').scrollIntoView(true);
    this.$emit('modalAsociacionEmit', false);
    this.$emit('datoEditado', true);
    this.dialog = false;
    this.handleClosed();
  }
}
